<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 资产类型切换 -->
      <div style="margin-bottom: 15px; padding-top: 5px">
        <el-radio-group v-model="currentItemType" size="small" @change="onItemTypeChange">
          <el-radio-button :label="1">固定资产</el-radio-button>
          <el-radio-button :label="2">易耗品</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 搜索表单 -->
      <el-form :model="searchParams" label-width="77px" class="ele-form-search" @keyup.enter.native="handleSearch"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="物品名称:">
              <el-input v-model="searchParams.itemName" placeholder="请输入物品名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="状态:">
              <el-select v-model="searchParams.status" placeholder="请选择" clearable class="ele-fluid">
                <el-option label="未分配" :value="0" />
                <el-option label="使用中" :value="1" />
                <el-option v-if="currentItemType === 1" label="维修中" :value="2" />
                <el-option v-if="currentItemType === 1" label="报废" :value="3" />
                <el-option v-if="currentItemType === 1" label="遗失" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="场室:">
              <el-cascader v-model="searchParams.roomId" :options="roomTree"
                :props="{ value: 'id', label: 'roomName', children: 'children', checkStrictly: true, emitPath: false }"
                placeholder="请选择场室" clearable filterable class="ele-fluid" />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="类别:">
              <el-cascader v-model="typeCascaderValue" :options="typeOptions"
                :props="{ value: 'id', label: 'typeName', children: 'children', checkStrictly: true, emitPath: false }"
                placeholder="请选择类别" clearable filterable class="ele-fluid" @change="onTypeChange" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :md="12" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="handleSearch" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 操作按钮栏 -->
      <div style="margin-bottom: 15px">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增资产</el-button>
        <el-button type="success" size="small" icon="el-icon-upload2" @click="importDialogVisible = true">导入</el-button>
        <el-button type="warning" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
        <el-button v-if="currentItemType === 1" type="info" size="small" icon="el-icon-picture-outline"
          @click="handleQrCode">生成二维码</el-button>
        <el-dropdown style="margin-left: 10px" @command="handleBatchAction">
          <el-button size="small">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">分配</el-dropdown-item>
            <el-dropdown-item :command="6">调配位置</el-dropdown-item>
            <el-dropdown-item :command="7">调配类目</el-dropdown-item>
            <el-dropdown-item v-if="currentItemType === 1" :command="2">维修</el-dropdown-item>
            <el-dropdown-item v-if="currentItemType === 1" :command="3">报废</el-dropdown-item>
            <el-dropdown-item v-if="currentItemType === 1" :command="4">遗失</el-dropdown-item>
            <el-dropdown-item :command="5" divided>删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="50" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="itemCode" label="物品编码" sortable="custom" show-overflow-tooltip min-width="120" />
          <el-table-column prop="itemName" label="物品名称" sortable="custom" show-overflow-tooltip min-width="130" />
          <el-table-column label="类型" align="center" width="90">
            <template #default="{ row }">
              <el-tag size="mini" :type="row.itemType === 2 ? 'warning' : 'primary'">
                {{ row.itemType === 2 ? '易耗品' : '固定资产' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="类别" show-overflow-tooltip min-width="100" />
          <el-table-column prop="roomName" label="所在场室" show-overflow-tooltip min-width="110" />
          <el-table-column label="状态" align="center" width="85">
            <template #default="{ row }">
              <el-tag size="mini" :type="statusTagType(row.status)">{{ statusLabel(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="currentItemType === 2" prop="itemNum" label="数量" align="center" width="70" />
          <el-table-column v-if="currentItemType === 2" prop="remainingNum" label="剩余数量" align="center" width="90" />
          <el-table-column prop="price" label="价格" align="center" width="90" />
          <el-table-column prop="procurementUser" label="采购人" show-overflow-tooltip width="100" />
          <el-table-column prop="procurementTime" label="采购日期" show-overflow-tooltip min-width="110" />
          <el-table-column prop="teacherName" label="分配教师" show-overflow-tooltip width="100" />
          <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="120" />
        </template>
      </ele-data-table>
    </el-card>

    <!-- 新增资产弹窗 -->
    <el-dialog title="新增资产" :visible.sync="addDialogVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="90px">
        <el-form-item label="物品名称" prop="itemName">
          <el-input v-model="addForm.itemName" placeholder="请输入物品名称" />
        </el-form-item>
        <div style="display: flex; gap: 15px;">
          <el-form-item label="数量" prop="itemNum" style="flex: 1;">
            <el-input-number v-model="addForm.itemNum" :min="1" class="ele-fluid" />
          </el-form-item>
          <el-form-item label="来源" prop="source" style="flex: 1;">
            <el-select v-model="addForm.source" placeholder="请选择" class="ele-fluid">
              <el-option label="采购" :value="1" />
              <el-option label="调拨" :value="2" />
              <el-option label="捐赠" :value="3" />
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex; gap: 15px;">
          <el-form-item label="类别" prop="typeId" style="flex: 1;">
            <el-cascader v-model="addForm.typeId" :options="typeOptions"
              :props="{ value: 'id', label: 'typeName', children: 'children', checkStrictly: true, emitPath: false }"
              placeholder="请选择类别" clearable filterable class="ele-fluid" />
          </el-form-item>
          <el-form-item label="所在场室" prop="roomId" style="flex: 1;">
            <el-select v-model="addForm.roomId" placeholder="请选择场室" clearable filterable class="ele-fluid">
              <el-option v-for="item in roomOptions" :key="item.id" :label="item.roomName" :value="item.id" />
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex; gap: 15px;">
          <el-form-item label="价格" prop="price" style="flex: 1;">
            <el-input v-model="addForm.price" placeholder="请输入价格" />
          </el-form-item>
          <el-form-item label="采购日期" prop="procurementTime" style="flex: 1;">
            <el-date-picker v-model="addForm.procurementTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
              class="ele-fluid" />
          </el-form-item>
        </div>
        <el-form-item label="采购人" prop="procurementUser">
          <el-input v-model="addForm.procurementUser" placeholder="请输入采购人" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addLoading" @click="handleAddSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量操作弹窗（分配/调配位置） -->
    <el-dialog :title="batchDialogTitle" :visible.sync="batchDialogVisible" width="450px" :close-on-click-modal="false">
      <el-form :model="batchForm" label-width="80px">
        <el-form-item v-if="batchForm.status === 1" label="分配教师">
          <treeselect v-model="batchForm.teacherId" :options="deptTeacher" :disable-branch-nodes="true"
            placeholder="请选择老师" :defaultExpandLevel="2" search-nested :normalizer="(d) => ({ id: d.id, label: d.name })"
            style="line-height: 20px" />
        </el-form-item>
        <el-form-item v-if="batchForm.status === 1 && isAllConsumable" label="分配数量">
          <el-input-number v-model="batchForm.num" :min="1" />
        </el-form-item>
        <el-form-item v-if="batchForm.status === 6" label="目标场室">
          <el-select v-model="batchForm.roomId" placeholder="请选择场室" clearable filterable class="ele-fluid">
            <el-option v-for="item in roomOptions" :key="item.id" :label="item.roomName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="batchForm.status === 7" label="目标类目">
          <el-cascader v-model="batchForm.typeId" :options="typeOptions"
            :props="{ value: 'id', label: 'typeName', children: 'children', emitPath: false }" placeholder="请选择类目"
            clearable filterable class="ele-fluid" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="batchLoading" @click="handleBatchSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog title="导入资产" :visible.sync="importDialogVisible" width="450px" :close-on-click-modal="false">
      <el-upload ref="upload" action="" :auto-upload="false" :limit="1" accept=".xlsx,.xls" class="ele-block"
        :on-change="onImportFileChange" :on-exceed="() => $message.warning('只能上传一个文件')" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          只能上传 xlsx / xls 文件，
          <el-link type="primary" :underline="false"
            href="https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1783995354217/导入资产.xlsx" download
            style="vertical-align: baseline">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="importLoading" @click="handleImport">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveItem, updateItem, importItem, exportItem, createQrCode, roomList, typeList } from '@/config/assetApi';
import { getAllDepartTeachers } from '@/config/api';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'AssetItem',
  components: { Treeselect },
  data () {
    return {
      currentItemType: 1, // 1=固定资产 2=易耗品
      searchParams: {
        itemName: '',
        typeId: '',
        roomId: '',
        status: '',
      },
      typeCascaderValue: '',
      roomOptions: [],
      roomTree: [],
      typeOptions: [],
      choose: [],
      table: {
        url: '/asset/itemList',
        where: { itemType: 1 },
        parseData (res) {
          if (res.data && res.resCode == 200) {
            res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          } else {
            res.code = 1;
            res.data = [];
            res.count = 0;
          }
          return res;
        },
      },
      // 新增弹窗
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        itemName: '',
        itemType: 1,
        itemNum: 1,
        typeId: '',
        roomId: '',
        price: '',
        procurementTime: '',
        procurementUser: '',
        source: 1,
        remark: '',
      },
      addRules: {
        itemName: [{ required: true, message: '请输入物品名称', trigger: 'blur' }],
        itemNum: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择类别', trigger: 'change' }],
        roomId: [{ required: true, message: '请选择所在场室', trigger: 'change' }],
        source: [{ required: true, message: '请选择来源', trigger: 'change' }],
      },
      // 批量操作弹窗
      batchDialogVisible: false,
      batchLoading: false,
      batchForm: {
        ids: '',
        status: 1,
        teacherId: null,
        num: 1,
        roomId: '',
        typeId: '',
      },
      // 导入
      importDialogVisible: false,
      importLoading: false,
      importFile: null,
      deptTeacher: [],
    };
  },
  computed: {
    isAllFixedAsset () {
      return this.currentItemType === 1;
    },
    isAllConsumable () {
      return this.currentItemType === 2;
    },
    batchDialogTitle () {
      const map = { 1: '分配资产', 6: '调配位置', 7: '调配类目' };
      return map[this.batchForm.status] || '操作';
    },
  },
  created () {
    this.fetchRoomOptions();
    this.fetchTypeOptions();
    this.fetchDeptTeachers();
  },
  methods: {
    statusLabel (status) {
      const map = { 0: '未分配', 1: '使用中', 2: '维修中', 3: '报废', 4: '遗失' };
      return map[status] || '';
    },
    statusTagType (status) {
      const map = { 0: 'info', 1: 'success', 2: 'warning', 3: 'danger', 4: 'danger' };
      return map[status] || 'info';
    },
    fetchRoomOptions () {
      roomList().then((res) => {
        if (res.data && res.data.resCode == 200 && res.data.data) {
          this.roomTree = res.data.data || [];
          this.roomOptions = this.flattenTree(res.data.data || []);
        }
      });
    },
    flattenTree (tree, result = []) {
      tree.forEach((node) => {
        result.push({ id: node.id, roomName: node.roomName });
        if (node.children && node.children.length) {
          this.flattenTree(node.children, result);
        }
      });
      return result;
    },
    fetchTypeOptions () {
      typeList({ type: this.currentItemType }).then((res) => {
        if (res.data && res.data.resCode == 200) {
          this.typeOptions = res.data.data || [];
        }
      });
    },
    fetchDeptTeachers () {
      getAllDepartTeachers().then((res) => {
        if (res.data && res.data.resCode == 200) {
          this.deptTeacher = res.data.data || [];
        }
      });
    },
    onTypeChange (val) {
      this.searchParams.typeId = val || '';
    },
    handleSearch () {
      this.table.where = { ...this.searchParams, itemType: this.currentItemType };
      this.$refs.table.reload();
    },
    handleReset () {
      this.searchParams = { itemName: '', typeId: '', roomId: '', status: '' };
      this.typeCascaderValue = '';
      this.table.where = { itemType: this.currentItemType };
      this.$refs.table.reload();
    },
    onItemTypeChange () {
      this.searchParams = { itemName: '', typeId: '', roomId: '', status: '' };
      this.typeCascaderValue = '';
      this.choose = [];
      this.table.where = { itemType: this.currentItemType };
      this.$refs.table.reload();
      this.fetchTypeOptions();
    },
    // 新增
    handleAdd () {
      this.addForm = {
        itemName: '',
        itemType: this.currentItemType,
        itemNum: 1,
        typeId: '',
        roomId: '',
        price: '',
        procurementTime: '',
        procurementUser: '',
        source: 1,
        remark: '',
      };
      this.addDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate();
      });
    },
    handleAddSubmit () {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.addLoading = true;
        saveItem(this.addForm)
          .then((res) => {
            if (res.data && res.data.resCode == 200) {
              this.$message.success('新增成功');
              this.addDialogVisible = false;
              this.$refs.table.reload();
            } else {
              this.$message.error((res.data && res.data.resMsg) || '新增失败');
            }
          })
          .finally(() => {
            this.addLoading = false;
          });
      });
    },
    // 批量操作
    handleBatchAction (status) {
      if (!this.choose.length) {
        this.$message.warning('请先选择要操作的资产');
        return;
      }
      // 维修/报废/遗失仅限固定资产
      if ([2, 3, 4].includes(status) && !this.isAllFixedAsset) {
        this.$message.warning('维修、报废、遗失操作仅支持固定资产');
        return;
      }
      const ids = this.choose.map((item) => item.id).join(',');
      this.batchForm = { ids, status, teacherId: null, num: 1, roomId: '', typeId: '' };

      if (status === 1 || status === 6 || status === 7) {
        this.batchDialogVisible = true;
      } else {
        const actionMap = { 2: '维修', 3: '报废', 4: '遗失', 5: '删除' };
        this.$confirm(`确定要将选中的 ${this.choose.length} 项资产进行【${actionMap[status]}】操作吗？`, '提示', {
          type: 'warning',
        })
          .then(() => {
            this.doBatchUpdate();
          })
          .catch(() => { });
      }
    },
    handleBatchSubmit () {
      this.batchLoading = true;
      this.doBatchUpdate()
        .then(() => {
          this.batchDialogVisible = false;
        })
        .finally(() => {
          this.batchLoading = false;
        });
    },
    doBatchUpdate () {
      let formData = new FormData();
      formData.append('ids', this.batchForm.ids);
      formData.append('status', this.batchForm.status);
      if (this.batchForm.teacherId) formData.append('teacherId', this.batchForm.teacherId);
      if (this.batchForm.num && this.isAllConsumable) formData.append('num', this.batchForm.num);
      if (this.batchForm.roomId) formData.append('roomId', this.batchForm.roomId);
      if (this.batchForm.typeId) formData.append('typeId', this.batchForm.typeId);
      return updateItem(formData).then((res) => {
        if (res.data && res.data.resCode == 200) {
          this.$message.success(res.data.resMsg);
          this.$refs.table.reload();
        } else {
          this.$message.error((res.data && res.data.resMsg) || '操作失败');
        }
      });
    },
    // 导出
    handleExport () {
      exportItem(this.searchParams).then((res) => {
        let blob = new Blob([res.data], { type: 'application/octet-stream' });
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '资产列表.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      });
    },
    // 生成二维码
    handleQrCode () {
      const hasSelection = this.choose.length > 0;
      const hasFilter = this.searchParams.itemName || this.searchParams.typeId || this.searchParams.roomId || this.searchParams.status !== '';
      if (!hasSelection && !hasFilter) {
        this.$message.warning('请至少勾选数据或设置筛选条件');
        return;
      }
      const idList = hasSelection ? this.choose.map((item) => item.id).join(',') : '';
      createQrCode({ ...this.searchParams, itemType: this.currentItemType, idList }).then((res) => {
        if (res.data && res.data.size > 0) {
          let blob = new Blob([res.data], { type: 'application/zip' });
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', '二维码.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
          this.$message.success('二维码下载成功');
        } else {
          this.$message.error('生成二维码失败');
        }
      });
    },
    // 导入
    onImportFileChange (file) {
      this.importFile = file.raw;
    },
    handleImport () {
      if (!this.importFile) {
        this.$message.warning('请先选择文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.importFile);
      this.importLoading = true;
      importItem(formData)
        .then((res) => {
          if (res.data && res.data.resCode == 200) {
            this.$message.success('导入成功');
            this.importDialogVisible = false;
            this.importFile = null;
            this.$refs.upload && this.$refs.upload.clearFiles();
            this.$refs.table.reload();
          } else {
            this.$message.error((res.data && res.data.resMsg) || '导入失败');
          }
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.ele-block {
  display: flex !important;
  flex-flow: column !important;
  align-items: center !important;
}
</style>
